'use client'
import { useSession } from 'next-auth/react'
import { useTranslations } from 'next-intl'
import React, { useMemo } from 'react'

import { useTopbarAddressShippingSwitcher } from '@maestro/commerce-blocks/components/header-topbar/batons/use-topbar-address-shipping-switcher'
import { Button } from '@pearlconvert/ui/components/button'

import '@maestro/commerce-blocks/components/header-topbar/styles/header-topbar.scss'

const HeaderTopbarAddressShippingSwitcher = () => {
  const { data: session } = useSession()
  const t = useTranslations('commerce-blocks.shipping-address-switcher')

  const {
    handleClickAddressShippingSwitcher,
    isUserLoggedIn,
    hasMultipleAddresses,
  } = useTopbarAddressShippingSwitcher()

  const shippingAddress = useMemo(() => {
    return session?.user?.company?.shippingAddress
  }, [session])

  if (!isUserLoggedIn || !hasMultipleAddresses) {
    return null
  }

  return (
    <Button
      type="link"
      iconRight="arrow-small-down"
      className="header-topbar__switcher"
      onClick={handleClickAddressShippingSwitcher}
    >
      {/* Omnium has no "default" address, so no address may be selected yet —
            fall back to the modal's title rather than waiting for a selection
            that may never come on its own. */}
      {shippingAddress?.name ?? t('title')}
    </Button>
  )
}

export default HeaderTopbarAddressShippingSwitcher
